// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"164d4b2f","147":"48198676","210":"88a75c7a","807":"a2a8d77d","899":"cbe3153e","900":"30817e25","945":"23fc0ae8","996":"135c9003"}[chunkId] + ".chunk.js";
};